import React from "react";

export const TrixContent = (props: any) => {
  return <div className="trix-content" dangerouslySetInnerHTML={{ __html: props.content }}></div>;
};
